import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';

export function useDisplayTemplateNode(root: MaybeRefOrGetter<boolean | undefined>) {
	const isNestedDisplayTemplateNode = computed(() => toValue(root) === false);
	const displayTemplateNodeElement = computed(() => isNestedDisplayTemplateNode.value ? 'span' : 'div');

	return {
		isNestedDisplayTemplateNode,
		displayTemplateNodeElement,
	};
}
